module.exports = {"Type":"ResetAllVars","Fields":[{"label":"Variables to exclude from reset","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"cornflowerblue","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/ResetAllVars.json
// module id = 702
// module chunks = 0